module.exports = __webpack_public_path__ + "media/images/icons/flags/BQ-54c5868284038db330a58596e276176e.svg";